import { gql } from "@apollo/client";
import { RealtimeInvoicePageResult } from "../types/RealtimeInvoiceType";

export const GET_REALTIME_INVOICES = gql`
    query GetRealtimeInvoices(
        $settlementClientId: ID!
        $dateFrom: Int
        $dateTo: Int
        $page: Int!
        $size: Int!
    ) {
        getRealtimeInvoices(
            settlementClientId: $settlementClientId
            dateFrom: $dateFrom
            dateTo: $dateTo
            page: $page
            size: $size
        ) {
            success
            code
            message
            content {
                invoiceId
                invoiceNo
                invoiceDate
                dueDate
                amount
                status
                currency
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export interface GetRealtimeInvoicesResponse {
    getRealtimeInvoices: RealtimeInvoicePageResult;
}
